import { useLayoutEffect, useCallback, useMemo, useState } from "react";
import ResizeObserver from "resize-observer-polyfill";

export function useResizeObserver(element) {
  const [dimensions, setDimensions] = useState(
    element
      ? { height: element.offsetHeight, width: element.offsetWidth }
      : { height: null, width: null },
  );

  const updateDimensions = useCallback(() => {
    if (!element) {
      return;
    }

    setDimensions({
      height: element.offsetHeight,
      width: element.offsetWidth,
    });
  }, [element]);

  // Observe size changes
  useLayoutEffect(() => {
    // Do not observe the size if we don't have a DOM element or if we have
    // _both_ a manual container height and width. THis custom logic is why we
    // didn't pull the observer out into it's own custom hook.
    if (!element) {
      return;
    }

    const resizeObserver = new ResizeObserver(updateDimensions);

    resizeObserver.observe(element);

    return () => {
      resizeObserver.unobserve(element);
    };
  }, [element, updateDimensions]);

  // Memoize the returned object so it doesn't cause unncessary re-renders
  const memoizedDimensions = useMemo(
    () => ({ width: dimensions.width, height: dimensions.height }),
    [dimensions.height, dimensions.width],
  );

  return memoizedDimensions;
}
